import { FormsConstants } from "src/app/constants/formsConstants";
import { ModalFormComponent } from "src/app/shared/modal-form/modal-form.component";
import { List } from "@ckeditor/ckeditor5-list";
import { PermisosTabla } from "./../../models/permisosTabla";
import {
  Component,
  NgZone,
  OnInit,
  Renderer2,
  setTestabilityGetter,
  ViewChild,
} from "@angular/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { MastertablesService } from "../mastertables.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { TokenService } from "src/app/core/services/token.service";
import { Mastertable } from "src/app/models/mastertable";
import { TranslateService } from "@ngx-translate/core";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { TableComponent } from "src/app/shared/table/table.component";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { Options } from "src/app/shared/filters/models/filters.model";
import { AppConstants } from "src/app/constants/app.constants";
import { take } from "rxjs/operators";

@Component({
  selector: "app-list-mastertables",
  templateUrl: "./list-mastertables.component.html",
  styleUrls: ["./list-mastertables.component.scss"],
})
export class ListMastertablesComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  @ViewChild("table") table: TableComponent;
  @ViewChild("modalPermisos") modalPermisos: ModalFormComponent;

  mastertables: string[];
  mastertableSelected: string = "0";
  dataOfMastertables;
  filtersTable: string;
  filtersTableJSON;
  filtersSearch = {
    arrayKeys: [],
    arrayValues: [],
  };
  filterList = [];
  tableList = [];
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  routing: any;
  options: Options = {
    arrowUpDown: false,
    create: true,
    delete: true,
    orderColumns: true,
    label: false,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: true,
    isMastertable: true,
  };
  public loading = {
    mastertables: true,
    dataOfMastertable: false,
  };
  type: string;
  showTableAndFilters: boolean = true;
  showTableFilter: boolean = false;
  showFilterButtons: boolean = false;
  orderBy: string;
  roles = AppConstants.roles;
  permisosTablas: PermisosTabla[];
  permisosTabla: PermisosTabla[];
  rolesToAssign = [this.roles.AAVANZA, this.roles.ABASICO, this.roles.ANALISTA];
  permisosRolesTabla: { [perfil: string]: boolean } = {};
  isAnalistUser: boolean = false;

  constructor(
    private mastertablesService: MastertablesService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private router: Router,
    private tokenService: TokenService,
    private sweetAlertService: SweetAlertService,
    private renderer: Renderer2,
    private ngZone: NgZone,
  ) {
    this.type = this.activatedRoute.data["_value"]["type"];
    if (this.type == "S") {
      this.routing = RoutingConstants.masterTableRoutingS;
    } else if (this.type == "D") {
      this.routing = RoutingConstants.masterTableRoutingD;
    }
  }

  ngOnInit(): void {
    this.isAnalistUser =
      this.tokenService.hasRole(this.roles.ANALISTA) ||
      this.tokenService.hasRole(this.roles.ABASICO) ||
      this.tokenService.hasRole(this.roles.AAVANZA);
    this.dataOfMastertables = null;
    this.filterList = null;
    this.tableList = null;
    this.mastertableSelected = "0";
    this.setState();
    this.getPermisosTabla();
  }

  private initFilters(): void {
    this.filtersTableJSON =
      this.filtersTableStateService.initFiltersTableMasterTable(
        this.orderBy,
        this.mastertableSelected,
        true,
      );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON,
    );
  }

  setState() {
    let state = this.mastertablesService.getCurrentState();
    if (state && state.mastertable && state.type == this.type) {
      this.mastertableSelected = state.mastertable;
      this.loadData(true);
    }
  }

  getPermisosTabla() {
    this.loading.mastertables = true;
    this.mastertablesService
      .getPermisosTablaByRole(this.tokenService.getRoles()[0])
      .subscribe(
        (data) => {
          this.permisosTablas = data;
          this.getMastertables();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        },
      );
  }

  getMastertables() {
    this.mastertablesService.list(this.type).subscribe(
      (data) => {
        const userRoles = this.tokenService.getRoles(); // array de perfiles del usuario
        if (this.isAnalistUser) {
          // Mostrar solo tablas con permiso 'S' para alguno de los roles del usuario
          this.mastertables = data.filter((mt) =>
            this.permisosTablas?.some(
              (pt) =>
                pt.tabla === mt &&
                pt.acceso === "S" &&
                userRoles.includes(pt.perfil),
            ),
          );
        } else {
          this.mastertables = data;
        }
        if (!this.mastertables || this.mastertables.length === 0) {
          this.toastrAlertService.toastrInfo(
            "Actualmente tu rol de usuario no dispone de ninguna tabla asignada",
          );
        }
        this.loading.mastertables = false;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      },
    );
  }

  goCreate() {
    this.router.navigate([this.routing.create]);
  }

  removeMastertable() {
    let mastertable = new Mastertable(this.mastertableSelected, this.type);
    this.mastertablesService.deleteMasterTable(mastertable).subscribe(
      (data) => {
        this.loading.mastertables = true;
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.mastertableSelected = "0";
        this.getMastertables();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      },
    );
  }

  loadData(init?: boolean) {
    if (this.mastertableSelected !== "0") {
      this.mastertablesService.setCurrentState({
        mastertable: this.mastertableSelected,
        type: this.type,
      });

      switch (this.mastertableSelected) {
        case "AyudasGenerales":
          this.orderBy = "AY_TITULO";
          break;
        case "MotivosRechazo":
        case "MotivosReedicion":
          this.orderBy = "MR_ID";
          break;
        default:
          this.orderBy = this.routing.id;
      }
      this.filtersSearch = init
        ? {
            arrayKeys: [],
            arrayValues: [],
          }
        : this.filtersTableStateService.composeParamsTwoArrays();

      if (init) {
        this.loading.dataOfMastertable = false;
        this.showFilterButtons = false;
        this.showTableAndFilters = true;
        this.showTableFilter = false;
        this.initFilters();

        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON,
        );
      }

      this.sweetAlertService.sweetAlertLoading();
      this.mastertablesService
        .listDataOfMasterTable(
          this.mastertableSelected,
          this.filtersTable,
          this.filtersSearch,
        )
        .subscribe(
          (data) => {
            this.mastertablesService
              .getPermisosTablaByTable(this.mastertableSelected)
              .subscribe(
                (dataPermisos) => {
                  this.permisosTabla = dataPermisos;
                  this.sweetAlertService.sweetAlertClose();
                },
                (err) => {
                  this.toastrAlertService.toastrFail(err.error.mensaje);
                },
              );
            this.showTableAndFilters = true;

            if (data.campos && data.campos.length == 0) {
              data.campos =
                this.mastertablesService.getCurrentFieldsStructure();
            }
            if (
              data.datos &&
              data.datos.length == 0 &&
              this.filtersSearch.arrayValues.length == 0 &&
              data.campos &&
              data.campos.length == 0
            ) {
              let message = this.translateService.instant(
                "messages.masterTableWihtoutData",
              );
              this.toastrAlertService.toastrFail(message);
              this.showTableAndFilters = false;
            }

            if (data.datos && data.datos.length == 0) {
              let message = this.translateService.instant(
                "messages.notFoundResutls",
              );
              this.toastrAlertService.toastrWarning(message);
            }

            this.dataOfMastertables = this.renderDataForTable(data);
            this.filterList = this.renderFieldsForFiltersSearch(data);
            this.tableList = this.renderFieldsToTable(data);
            this.numPages =
              data.numTotalPaginas == 0 ? 1 : data.numTotalPaginas;
            this.numElements = data.datos.length;
            this.totalElements = data.numTotalRegistros;
            this.mastertablesService.setCurrentFieldsStructure(data.campos);

            if (this.table && this.table.checkedElementList) {
              this.table.checkedElementList = [];
              this.table.checkedElementListData = [];
            }

            if (this.filterList.findIndex((e) => e.filterValue == "ID") != -1) {
              this.filterList.splice(
                this.filterList.findIndex((e) => e.filterValue == "ID"),
                1,
              );
              this.tableList.splice(
                this.tableList.findIndex((e) => e.objectKey == "ID"),
                1,
              );
            }

            this.hideColumnsByMasterTable();

            this.loading.dataOfMastertable = true;
          },
          (err) => {
            this.sweetAlertService.sweetAlertClose();
            let message = this.translateService.instant(
              "messages.masterTableWihtoutData",
            );
            this.toastrAlertService.toastrFail(message);
            this.showTableAndFilters = false;
          },
        );
    }
  }

  private hideColumnsByMasterTable(): void {
    switch (this.mastertableSelected) {
      case "AyudasGenerales":
        this.hideFromFilterAndTable("AY_TEXTO");
        break;
      case "Precios":
        this.hideFromFilterAndTable("PR_MARCOLEGAL");
        break;
      default:
        break;
    }
  }

  private hideFromFilterAndTable(field: string): void {
    this.filterList.splice(
      this.filterList.findIndex((e) => e.filterValue == field),
      1,
    );
    this.tableList.splice(
      this.tableList.findIndex((e) => e.objectKey == field),
      1,
    );
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.loadData();
  }

  removeElements(ids: string[]) {
    this.mastertablesService
      .deleteDataOfMasterTable(ids, this.mastertableSelected)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.initFilters();
          this.filtersTable = this.filtersTableStateService.getString(
            this.filtersTableJSON,
          );
          this.loadData();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        },
      );
  }

  renderDataForTable(data): any[] {
    let render = [];

    data.datos.forEach((arrayElement) => {
      let object = new Object();
      arrayElement.forEach((item, index) => {
        if (index === 0) {
          object["rowid"] = item;
        } else {
          object[data.campos[index - 1].nombre] = item;
        }
      });
      render.push(object);
    });

    return render;
  }

  renderFieldsForFiltersSearch(data): any[] {
    let render = [];
    let types = FilterConstants.types;

    data.campos.forEach((element) => {
      let object;

      let label: string = element.nombre.substring(
        element.nombre.indexOf("_") + 1,
      );

      object = {
        label: label,
        type: types[element.tipo],
        filterValue: element.nombre,
        styles: { width: "26px" },
      };

      render.push(object);
    });

    return render;
  }

  renderFieldsToTable(data): any[] {
    let render = [];

    data.campos.forEach((element) => {
      let object;
      object = {
        labelHeader: element.nombre,
        objectKey: element.nombre,
        order: element.nombre,
      };
      render.push(object);
    });

    return render;
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersValuesSearch = [];
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParamsTwoArrays();
        this.filtersTableStateService.setPageState(1);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON,
        );
        this.loadData();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          this.showFilterButtons = false;
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }

  openPermisosTablaModal(): void {
    if (!this.mastertableSelected || this.mastertableSelected === "0") return;
    this.rolesToAssign.forEach((r) => (this.permisosRolesTabla[r] = false));
    this.mastertablesService
      .getPermisosTablaByTable(this.mastertableSelected)
      .subscribe(
        (data: PermisosTabla[]) => {
          (data || []).forEach((p) => {
            if (this.rolesToAssign.includes(p.perfil)) {
              this.permisosRolesTabla[p.perfil] = p.acceso === "S";
            }
          });

          const form = [
            ...FormsConstants.permisosTablaRolesForm.map((f) => ({
              ...f,
              value: this.permisosRolesTabla[f.key],
            })),
          ];

          this.modalPermisos.open(form, "lg");

          this.ngZone.onStable
            .pipe(take(1))
            .subscribe(() => this.insertPermisosHeader());
        },
        (err) => this.toastrAlertService.toastrFail(err.error.mensaje),
      );
  }

  private insertPermisosHeader(): void {
    const formEl = document.querySelector<HTMLElement>(".locatorPermisosTabla");
    if (!formEl) return;
    if (formEl.querySelector(".permisos-header")) return;

    const header = this.renderer.createElement("div");
    const headerPerfil = this.renderer.createElement("div");
    const headerCheck = this.renderer.createElement("div");

    this.renderer.addClass(header, "permisos-header");
    this.renderer.addClass(header, "py-2");
    this.renderer.addClass(header, "row");
    this.renderer.addClass(headerPerfil, "col-6");
    this.renderer.addClass(headerPerfil, "px-4");
    this.renderer.addClass(headerPerfil, "mb-0");
    this.renderer.addClass(headerCheck, "col-6");
    this.renderer.addClass(headerCheck, "mb-0");
    this.renderer.addClass(headerCheck, "text-center");

    this.renderer.setProperty(headerPerfil, "textContent", "Perfil");
    this.renderer.setProperty(headerCheck, "textContent", "S/N");

    this.renderer.appendChild(header, headerPerfil);
    this.renderer.appendChild(header, headerCheck);

    const first = formEl.firstChild;
    if (first) {
      this.renderer.insertBefore(formEl, header, first);
    } else {
      this.renderer.appendChild(formEl, header);
    }

    let i = 0;
    const perfiles = formEl.querySelectorAll<HTMLElement>(".itemContainer");
    perfiles.forEach((perfilEl) => {
      this.renderer.removeClass(perfilEl, "col");
      this.renderer.addClass(perfilEl, "row");
      this.renderer.addClass(perfilEl, "py-2");
      this.renderer.addClass(perfilEl, "align-items-center");
      if (i === 1) this.renderer.addClass(perfilEl, "grey-row");

      const parent = perfilEl.parentElement;
      if (parent) {
        this.renderer.removeClass(parent, "shortRow");
        const parent2 = parent.parentElement;
        if (parent2) {
          this.renderer.removeClass(parent2, "mb-3");
        }
      }

      const labelWrap = perfilEl.querySelector(".inputLabelContainer");
      if (labelWrap) {
        this.renderer.addClass(labelWrap, "col-6");
        this.renderer.addClass(labelWrap, "px-4");
      }

      const inputWrap = perfilEl.querySelector(".inputContainer");
      if (inputWrap) {
        this.renderer.addClass(inputWrap, "col-6");
        this.renderer.addClass(inputWrap, "text-center");
      }
      i++;
    });
  }

  savePermisosTablaRoles(event: any): void {
    const permisos: PermisosTabla[] = event.form.map(
      (f) =>
        new PermisosTabla(this.mastertableSelected, f.key, f.value ? "S" : "N"),
    );
    this.mastertablesService.updatePermisosTablaForTable(permisos).subscribe(
      (resp) => {
        this.toastrAlertService.toastrSuccess(
          resp?.mensaje || "Permisos guardados",
        );
        this.getPermisosTabla();
        this.getMastertables();
      },
      (err) =>
        this.toastrAlertService.toastrFail(err.error?.mensaje || "Error"),
    );
  }
}
